import { render, staticRenderFns } from "./MobileHistory.vue?vue&type=template&id=32d7fe41&scoped=true&"
import script from "./MobileHistory.vue?vue&type=script&lang=js&"
export * from "./MobileHistory.vue?vue&type=script&lang=js&"
import style0 from "./MobileHistory.vue?vue&type=style&index=0&id=32d7fe41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d7fe41",
  null
  
)

export default component.exports